import { NuqsAdapter } from 'nuqs/adapters/react-router/v7'
import type { PropsWithChildren } from 'react'
import { BrowserRouter } from 'react-router-dom'

export { RouterProvider }

const RouterProvider = ({ children }: PropsWithChildren) => {
  return (
    <BrowserRouter>
      <NuqsAdapter>{children}</NuqsAdapter>
    </BrowserRouter>
  )
}
